import { Injectable } from "@angular/core";
import { ConfigurationService } from "./configuration.service";
import { Observable } from "rxjs";
import { NsWISConfigurations } from "../models/configurations.model";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";
import { BookingDataService } from "./booking-data.service";
import { EmpUserService } from "./emp-user.service";
import { HomeDataService } from "./home-data.service";
import { PreferenceDataService } from "./preference-data.service";

@Injectable({
  providedIn: "root"
})
export class FormsService {
  userStream: Observable<NsEmpWebExpData.IEmployee>;
  globalConfigStream: Observable<NsWISConfigurations.IConfigurations>;

  constructor(
    private user: EmpUserService,
    private config: ConfigurationService,
    private homeData: HomeDataService,
    private bookingData: BookingDataService,
    private preferenceData: PreferenceDataService
  ) {}

  beginFormStreams(buid: string, empGuid: string): void {
    this.user.setUser(buid, empGuid);
    this.config.refreshReplayStreams();
    this.homeData.refreshReplayStreams();
    this.bookingData.refreshReplayStreams();
    this.preferenceData.refreshReplayStreams();
    this.userStream = this.homeData.employeeInfo;
    this.globalConfigStream = this.config.configurations;
  }

  createBookingConfig(
    userConfigs: NsWISConfigurations.IConfigurations,
    profile: NsEmpWebExpData.IEmployee,
    type: NsEmpWebExpData.IBookingRequestType,
    data?: NsEmpWebExpData.INearbyBooking
  ): NsEmpWebExpData.IBookingFormConfig {
    return this.bookingData.setFormForCreate(userConfigs, profile, type, data);
  }

  setBookingTimezone(zone: string): void {
    this.bookingData.timezone = zone;
  }
}
